import type { BaseResponse, PersonalMessage } from "@anggunpraya-templates/types";
import type { DeepPartial } from "@nuxt/ui/runtime/types/utils.js";
import { PAGING } from "@anggunpraya-templates/base/app/constant";

export const PREVIEW_WISHES_DATA: BaseResponse<DeepPartial<PersonalMessage>, true> = {
  success: true,
  error: null,
  paging: {
    ...PAGING,
  },
  data: [
    {
      personal_message_id: "PM-001",
      guest_name: "Fulan",
      status: "attending",
      message: "Barakallahu laka wa baraka 'alaika, semoga langgeng sampai jannah. 🤍",
    },
    {
      personal_message_id: "PM-002",
      guest_name: "Fulanah",
      status: "not-attending",
      message: "Semoga menjadi keluarga sakinah, mawaddah, warahmah. 🌿",
    },
    {
      personal_message_id: "PM-003",
      guest_name: "Fulan",
      status: "not-attending",
      message: "Selamat menempuh hidup baru! Semoga saling menguatkan di setiap musim. 🍃",
    },
    {
      personal_message_id: "PM-004",
      guest_name: "Fulanah",
      status: "attending",
      message: "Doa terbaik untuk kalian berdua—rezeki lapang, cinta tak berkurang. ✨",
    },
    {
      personal_message_id: "PM-005",
      guest_name: "Fulan",
      status: "attending",
      message: "Semoga rumah tangga jadi tempat pulang yang paling damai. 🏡",
    },
    {
      personal_message_id: "PM-006",
      guest_name: "Fulanah",
      status: "not-attending",
      message: "Saling menggandeng saat lapang, saling menguatkan saat sempit. 🤝",
    },
    {
      personal_message_id: "PM-007",
      guest_name: "Fulan",
      status: "not-attending",
      message: "Cinta itu ibadah—semoga setiap harinya bernilai pahala. 🕊️",
    },
    {
      personal_message_id: "PM-008",
      guest_name: "Fulanah",
      status: "attending",
      message: "Semoga dilimpahi kebahagiaan, kesabaran, dan tawa yang panjang. 😂💫",
    },
    {
      personal_message_id: "PM-009",
      guest_name: "Fulan",
      status: "attending",
      message: "Dua insan, satu tujuan: ridha Allah. Semoga selalu sejalan. 🌙",
    },
    {
      personal_message_id: "PM-010",
      guest_name: "Fulanah",
      status: "not-attending",
      message: "Selamat! Semoga setiap langkah ditemani berkah. 🌸",
    },
    {
      personal_message_id: "PM-011",
      guest_name: "Fulan",
      status: "attending",
      message: "Bersatu bukan untuk sempurna, tapi untuk saling menyempurnakan. ♾️",
    },
    {
      personal_message_id: "PM-012",
      guest_name: "Fulanah",
      status: "attending",
      message: "Semoga rezeki lancar, komunikasi lancar, cinta kian lebar. 💌",
    },
    {
      personal_message_id: "PM-013",
      guest_name: "Fulan",
      status: "not-attending",
      message: "Pantun dikit: bunga mawar harum mewangi, semoga cinta abadi sampai nanti. 🌹",
    },
    {
      personal_message_id: "PM-014",
      guest_name: "Fulanah",
      status: "not-attending",
      message: "Hari ini janji, esok konsistensi—semoga Allah jaga selalu. 🤲",
    },
    {
      personal_message_id: "PM-015",
      guest_name: "Fulan",
      status: "attending",
      message: "Semoga jadi tim solid: satu visi, satu misi, satu hati. 🧩",
    },
    {
      personal_message_id: "PM-016",
      guest_name: "Fulanah",
      status: "attending",
      message: "Bahagia sederhana: sarapan bareng dan saling mendoakan. 🥐☕",
    },
    {
      personal_message_id: "PM-017",
      guest_name: "Fulan",
      status: "not-attending",
      message: "Semoga Allah mudahkan setiap urusan dan jauhkan dari perselisihan. 🛡️",
    },
    {
      personal_message_id: "PM-018",
      guest_name: "Fulanah",
      status: "attending",
      message: "Cinta yang baik selalu tumbuh; semoga tumbuhnya di jalan yang benar. 🌱",
    },
    {
      personal_message_id: "PM-019",
      guest_name: "Fulan",
      status: "not-attending",
      message: "Langgeng, harmonis, dan penuh syukur dari hari ke hari. 🙏",
    },
    {
      personal_message_id: "PM-020",
      guest_name: "Fulanah",
      status: "not-attending",
      message: "Selamat menata rumah, menata hati, menata masa depan. 🏠✨",
    },
  ],
};
